import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getCategories } from '../../api';
import { FiMapPin, FiPhone, FiMail, FiFacebook, FiInstagram, FiTwitter, FiYoutube } from 'react-icons/fi';
import './Footer.css';

const Footer = () => {
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    getCategories({ page_size: 8 }).then(({ data }) => setCategories(data.results || [])).catch(() => {});
  }, []);

  return (
  <footer className="footer">
    <div className="footer-inner container">
      <div className="footer-brand">
        <div className="footer-logo">
          <span className="logo-dji">DJI</span>
          <span className="logo-nepal">Nepal</span>
        </div>
        <p className="footer-tagline">Official DJI Authorized Dealer in Nepal. Fly smarter, see further.</p>
        <div className="footer-socials">
          <a href="#!"><FiFacebook /></a>
          <a href="#!"><FiInstagram /></a>
          <a href="#!"><FiTwitter /></a>
          <a href="https://www.youtube.com/@nomadictravel-np"><FiYoutube /></a>
        </div>
      </div>

      <div className="footer-col">
        <h4>Products</h4>
        {categories.slice(0, 6).map((cat) => (
          <Link key={cat.id} to={`/products?category=${cat.slug}`}>{cat.name}</Link>
        ))}
      </div>

      <div className="footer-col">
        <h4>Explore</h4>
        <Link to="/products">All Products</Link>
        <Link to="/second-hand">Second Hand</Link>
        <Link to="/second-hand/sell">Sell Your Gear</Link>
        <Link to="/blog">Blog</Link>
        <Link to="/dashboard">My Orders</Link>
      </div>

      <div className="footer-col">
        <h4>Contact</h4>
        <div className="contact-item"><FiMapPin /> Ground Floor, Infinity Tower Gongabu,Kathmandu, Nepal</div>
        <div className="contact-item"><FiPhone /> +977-9860807878</div>
        <div className="contact-item"><FiMail /> info@djistorenepal.com</div>
        <div className="footer-pay">
          <span>Khalti</span>
          <span>Fonepay</span>
          <span>Bank Transfer</span>
          <span>Cash on Delivery</span>
        </div>
      </div>
    </div>

    <div className="footer-bottom container">
      <p>&copy; {new Date().getFullYear()} DJI Nepal. All rights reserved.</p>
      <p>Prices in NPR · Payments secured by Khalti &amp; Fonepay</p>
    </div>
  </footer>
  );
};

export default Footer;